import axios from 'axios';

const state = {
	loading: false,
	createStatus: '',
	updateStatus: '',
	estados: [],
	distribuidores: [],
	totalDistribuidores: null,
	search: '',
	// paginacion
	pageSize: 10,
	pageNum: 1
};
export const namespaced = true;

const mutations = {
	setLoading: (state, value) => {
		state.loading = value;
	},
	setEstados: (state, value) => {
		state.estados = value;
	},
	setDistribuidores: (state, value) => {
		state.distribuidores = value;
	},
	setTotalDistribuidores: (state, value) => {
		state.totalDistribuidores = value;
	},
	setCreateStatus: (state, value) => {
		state.createStatus = value;
	},
	setUpdateStatus: (state, value) => {
		state.updateStatus = value;
	},
	// paginacion
	setPageSize: (state, value) => {
		state.pageSize = value;
	},
	setPageNum: (state, value) => {
		state.pageNum = value;
	},
	setSearch: (state, value) => {
		state.search = value;
	},
};

const actions = {
	async getEstados({ commit }) {
		try {
			const res = await axios.get('/getEstados.php');
			if (res.status === 200) {
				const estados = res.data.estados.map((item) => {
					return { value: item.idEstado, text: item.Estado };
				});
				commit('setEstados', estados);
			}
		} catch (error) {
			console.log(error);
		}
	},
	async createDistribuidor({ commit, dispatch }, data) {
		const form = {
			accion: 'create',
			direccionDis: data.direccionDis,
			email: data.email,
			nombreDis: data.nombreDis,
			idEstado: data.state,
			activo: data.status,
			tel1: data.tel1,
			tel2: data.tel2,
			tel3: data.tel3,
			web: data.web
		};

		try {
			commit('setLoading', true);
			await axios.post('/distribuidores.php', form);
			commit('setCreateStatus', 'success');
			dispatch(
				'ui/makeToast',
				{
					title: 'Distribuidor creado con exito.'
				},
				{ root: true }
			);
			await dispatch('getDistribuidores');
		} catch (err) {
			console.log(err);
			commit('setCreateStatus', 'failed');
			dispatch(
				'ui/makeToast',
				{
					icon: 'error',
					title: 'Ocurrio un error al crear el distribuidor.'
				},
				{ root: true }
			);
		} finally {
			commit('setLoading', false);
		}
	},

	async updateDistribuidor({ commit, dispatch }, data) {
		commit('setUpdateStatus', '');
		const form = {
			accion: 'update',
			idDistribuidor: data.idDistribuidor,
			direccionDis: data.direccionDis,
			email: data.email,
			nombreDis: data.nombreDis,
			idEstado: data.state,
			activo: data.status,
			tel1: data.tel1,
			tel2: data.tel2,
			tel3: data.tel3,
			web: data.web
		};
		try {
			commit('setLoading', true);
			await axios.put('/distribuidores.php', form);
			commit('setUpdateStatus', 'success');
			dispatch(
				'ui/makeToast',
				{
					title: 'Distribuidor actualizado con exito.'
				},
				{ root: true }
			);
			await dispatch('getDistribuidores');
		} catch (err) {
			console.log(err);
			commit('setUpdateStatus', 'failed');
			dispatch(
				'ui/makeToast',
				{
					icon: 'error',
					title: 'Ocurrio un error al actualizar el distribuidor.'
				},
				{ root: true }
			);
		} finally {
			commit('setLoading', false);
		}
	},
	async deleteDistribuidor({ commit, dispatch }, idDistribuidor) {
		const form = {
			accion: 'delete',
			idDistribuidor
		};
		try {
			commit('setLoading', true);
			await axios.delete('/distribuidores.php', { data: form });
			dispatch(
				'ui/makeToast',
				{
					title: 'Distribuidor eliminado con exito.'
				},
				{ root: true }
			);
			await dispatch('getDistribuidores');
		} catch (err) {
			console.log(err);
			dispatch(
				'ui/makeToast',
				{
					icon: 'error',
					title: 'Ocurrio un error al eliminar el distribuidor.'
				},
				{ root: true }
			);
		} finally {
			commit('setLoading', false);
		}
	},
	async getDistribuidores({ commit, dispatch, state }) {
		commit('setLoading', true);
		try {
			const data = {
				accion: 'getAll'
			};
			const res = await axios.post(
				`/distribuidores.php?pageSize=${state.pageSize}&pageNum=${state.pageNum}&search=${state.search}`,
				data
			);
			commit('setDistribuidores', res.data.distribuidores);
			if (state.pageNum === 1) {
				commit('setTotalDistribuidores', res.data.total);
			}
		} catch (error) {
			dispatch(
				'ui/makeToast',
				{
					icon: 'error',
					title: 'Ocurrio un error al consultar los distribuidores.'
				},
				{ root: true }
			);
			console.log(error);
		} finally {
			commit('setLoading', false);
		}
	}
};

export default {
	state,
	actions,
	mutations,
	namespaced: true
};
